<app-container>
  <ng-container *ngIf="offers | async as offersModel; else loading">
    <div class="flex flex-col">
      <div class="container flex flex-row flex-wrap items-stretch justify-start">
        <app-offer-tile
          *ngFor="let offer of offersModel.offers"
          [offer]="offer"
          class="w-1/3"
          fxFlex.lt-md="50"
          fxFlex.xs="100"
        ></app-offer-tile>
      </div>
    </div>

    <app-empty-state *ngIf="!offersModel.offers.length" imagePath="/assets/images/undraw/trypay/undraw_gift1_sgf8.svg">
      <span class="text-lg">Brak ofert</span>
      <span class="text-center">
        <ng-container *ngIf="offersModel.hasCategories; else noCategories">
          Wkrótce pojawią się tu dopasowane do<br />
          Ciebie oferty, które pozwolą Ci zaoszczędzić.
        </ng-container>
        <ng-template #noCategories>
          Dbamy o to, żeby oferty były zawsze atrakcyjne<br />
          i w pełni dopasowane do Twoich potrzeb.<br />
          Powiedz, co Cię interesuje, a pokażemy Ci najlepsze oferty.
        </ng-template>
      </span>
    </app-empty-state>
  </ng-container>

  <ng-template #loading>
    <app-loading></app-loading>
  </ng-template>
</app-container>
